import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/avisoNP`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const postAvisoNP = async (aviso) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(``), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(aviso),
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchAvisoNp = async (itemId, aviso) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`${itemId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(aviso),
  });

  res = await parseJSON(res);

  return res.success;
};

export const getUbicacion = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);

  let res = await fetch(readUrl(`ubicacion?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
